type GetAssetsPathWithPrefix = () => string;

// TODO: Скопировано из основного кода проекта. Подумать как его выделить отдельно.
export const checkIsElectron = () => {
    // Renderer process
    if (
        typeof window !== 'undefined' &&
        typeof window.process === 'object' &&
        (window.process as any).type === 'renderer'
    ) {
        return true;
    }

    // Main process
    if (
        typeof process !== 'undefined' &&
        typeof process.versions === 'object' &&
        !!(process.versions as any).electron
    ) {
        return true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    return (
        typeof navigator === 'object' &&
        typeof navigator.userAgent === 'string' &&
        navigator.userAgent.indexOf('Electron') >= 0
    );
};

export const isElectron = checkIsElectron();

const getAssetsPathPrefix: GetAssetsPathWithPrefix = () => (isElectron ? '' : '/');

export const ASSETS_PATH_PREFIX = getAssetsPathPrefix();

/**
 * Резолвит относительный URL ассета к абсолютному для Electron.
 *
 * Зачем: в Electron webpack даёт wasm-ассетам `publicPath: '../../'` (относительно воркеров
 * в `static/js/` — см. webpack.prod.electron.js). Это работает для воркеров, но из главного
 * потока (React-компоненты) `../../` уходит вверх мимо `app.asar/webapp/` в `resources/`,
 * и файл не находится.
 *
 * Использовать ТОЛЬКО из главного потока (использует `window.location`).
 * Воркерам не нужно — они и так резолвят относительно своей локации в `static/js/`.
 *
 * Pre-condition: webpack электрон-сборки кладёт wasm-ассеты с publicPath относительно `static/js/`.
 */
export const resolveAssetUrl = (url: string): string => {
    if (!isElectron) return url;

    return new URL(url, new URL('./static/js/', window.location.href)).href;
};
